import { render, staticRenderFns } from "./role-m.vue?vue&type=template&id=3281ef17&scoped=true&"
import script from "./role-m.vue?vue&type=script&lang=js&"
export * from "./role-m.vue?vue&type=script&lang=js&"
import style0 from "./role-m.vue?vue&type=style&index=0&id=3281ef17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3281ef17",
  null
  
)

export default component.exports